import { LOGO_URL } from "../lib/brand";
import { ShieldCheck, Mail, Phone, MapPin } from "lucide-react";

export const Footer = () => (
  <footer id="contacto" className="brand-navy mt-24 text-white">
    <div className="mx-auto grid max-w-7xl gap-10 px-6 py-16 sm:grid-cols-2 lg:grid-cols-4">
      <div>
        <div className="mb-4 inline-flex rounded-xl bg-white px-3 py-2">
          <img src={LOGO_URL} alt="VALORA" className="h-10 w-auto object-contain" />
        </div>
        <p className="text-sm leading-relaxed text-slate-300">
          Tu competencia, certificada. Formación con validez oficial en competencia laboral para
          profesionales de México.
        </p>
      </div>
      <div>
        <h4 className="eyebrow mb-4 text-emerald-300">Programas</h4>
        <ul className="space-y-2 text-sm text-slate-300">
          <li>Talleres</li>
          <li>Cursos</li>
          <li>Diplomados</li>
          <li>Masters</li>
        </ul>
      </div>
      <div>
        <h4 className="eyebrow mb-4 text-emerald-300">Confianza</h4>
        <ul className="space-y-3 text-sm text-slate-300">
          <li className="flex items-center gap-2"><ShieldCheck className="h-4 w-4 text-emerald-400" /> Certificaciones oficiales</li>
          <li className="flex items-center gap-2"><ShieldCheck className="h-4 w-4 text-emerald-400" /> Pago seguro con PayPal</li>
          <li className="flex items-center gap-2"><ShieldCheck className="h-4 w-4 text-emerald-400" /> Asesor personalizado</li>
        </ul>
      </div>
      <div>
        <h4 className="eyebrow mb-4 text-emerald-300">Contacto</h4>
        <ul className="space-y-3 text-sm text-slate-300">
          <li className="flex items-center gap-2"><Mail className="h-4 w-4" /> hola@valora.mx</li>
          <li className="flex items-center gap-2"><Phone className="h-4 w-4" /> +52 55 0000 0000</li>
          <li className="flex items-center gap-2"><MapPin className="h-4 w-4" /> Ciudad de México</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10 py-6 text-center text-xs text-slate-400">
      © {new Date().getFullYear()} VALORA · Certificaciones de Competencia Laboral. Todos los derechos reservados.
    </div>
  </footer>
);
